import { QuestionChoiceModel } from './questionChoice.model';

export class QuestionModel {
  id: string;
  text: string;
  elementType: string;
  isActive: boolean;
  formElementChoices: Array<QuestionChoiceModel> = [];
  orderIndex: number;
}
